import {
	generateUtilityClass,
	generateUtilityClasses,
} from '@netx/core-components/Theme/utils';

export const USER_RULE_EDITOR_CLASS_NAME = 'UserRuleEditor';
export const USER_RULE_EDITOR_CLASS_SLOTS = ['root'] as const;

export type UserRuleEditorClassSlot =
	(typeof USER_RULE_EDITOR_CLASS_SLOTS)[number];

export interface UserRuleEditorClasses {
	root: string;
}

export type UserRuleEditorClassKey = keyof UserRuleEditorClasses;

export const getUserRuleEditorUtilityClass = (slot: string) =>
	generateUtilityClass(USER_RULE_EDITOR_CLASS_NAME, slot);

export const userRuleEditorClasses: UserRuleEditorClasses =
	generateUtilityClasses(USER_RULE_EDITOR_CLASS_NAME, ['root']);

export default userRuleEditorClasses;
